import React from 'react';
import EventProvider from 'context/events/Event';
import CollapseProvider from 'context/general/Collapse';
import OnSelectMenuProvider from 'context/general/OnSelectMenu';
import DashHeader from 'modules/dashboard/_common/DashHeader';
import DashHeaderActions from 'modules/dashboard/_common/DashHeaderActions';
import ProducerPublicPage from 'modules/producer/ProducerPublicPage';
import styled from 'styled-components';
import breakpoints from 'theme/breakpoints';

export default function ProducerPage() {
    return (
        <EventProvider>
            <CollapseProvider>
                <OnSelectMenuProvider>
                    <StyledHeader>
                        <DashHeader userView={true} />
                        <DashHeaderActions />
                    </StyledHeader>

                    <ProducerPublicPage />
                </OnSelectMenuProvider>
            </CollapseProvider>
        </EventProvider>
    );
}

const StyledHeader = styled.span`
    display: none;
    @media screen and (min-width: ${breakpoints.lg}) {
        display: flex;
    }
`;
